module.exports = __webpack_public_path__ + "static/media/lego-logo.d4a6e390.svg";